import { render, staticRenderFns } from "./BolsaAppAsideBarMovil.vue?vue&type=template&id=490cbe28&scoped=true"
import script from "./BolsaAppAsideBarMovil.vue?vue&type=script&lang=js"
export * from "./BolsaAppAsideBarMovil.vue?vue&type=script&lang=js"
import style0 from "./BolsaAppAsideBarMovil.vue?vue&type=style&index=0&id=490cbe28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490cbe28",
  null
  
)

export default component.exports